module.exports = __webpack_public_path__ + "img/garry-pro.cdd8338e.jpg";